import ApiInstance from '@/middlewares/api-interceptore';
import { ROUTES } from './routes';

const getHomePatient = async () => {
  const { data } = await ApiInstance.get(`${ROUTES.HOME_PATIENT}/current`);
  return data;
};

const postSession = async payload => {
  const { data } = await ApiInstance.post(`${ROUTES.HOME_PATIENT}/offline`, payload, {});
  return data;
};

const postOnlineSession = async payload => {
  const { data } = await ApiInstance.post(`${ROUTES.HOME_PATIENT}/online`, payload, {});
  return data;
};

const getSession = async id => {
  const { data } = await ApiInstance.get(`${ROUTES.HOME_PATIENT}/${id}`);
  return data;
};

const postResumeSession = async ({ id, payload }) => {
  const { data } = await ApiInstance.post(
    `${ROUTES.HOME_PATIENT}/online/${id}/resume`,
    payload,
    {}
  );
  return data;
};

const postSessionFeedback = async ({ id, payload }) => {
  const { data } = await ApiInstance.post(`${ROUTES.HOME_PATIENT}/${id}/feedback`, payload, {});
  return data;
};

const postSessionFeedbackSkip = async ({ id }) => {
  const { data } = await ApiInstance.post(`${ROUTES.HOME_PATIENT}/${id}/feedback/skip`);
  return data;
};

export const homePatientApi = {
  getHomePatient,
  postSession,
  postOnlineSession,
  getSession,
  postResumeSession,
  postSessionFeedback,
  postSessionFeedbackSkip,
};
